import { useRef } from 'react';
import {
	Grid,
	Card,
	CardContent,
	IconButton,
	useMediaQuery,
	Divider,
	Button,
	Typography,
	Box,
	List,
	Avatar,
	ImageList,
	ImageListItem,
	ListItem,
	ListItemText,
	ListItemAvatar,
	CardActions,
} from '@mui/material';

// import { LazyLoadImage } from 'react-lazy-load-image-component';
import { alpha, useTheme } from '@mui/material/styles';
import LaptopSkeletonIllustration from '~/content/svg/illustrations/LaptopSkeleton';
import { ImageLoader } from '~/content/components/ImageLoader';
import Scroll from 'react-scroll';
//? https://www.npmjs.com/package/react-scroll
import { useTranslation } from 'react-i18next';

import dashboard_laptop from '~/content/images/applications/dashboard.webp';
import { Link, useLocation, useLoaderData } from '@remix-run/react';

const Hero = (): JSX.Element => {
	const dashboard_laptopRef_1 = useRef(null);
	const dashboard_laptopRef_2 = useRef(null);
	let { t } = useTranslation(['applications']);
	const theme = useTheme();
	const { userLanguage } = useLoaderData();
	const link_prefix = userLanguage === 'en' ? '/en' : '';

	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true,
	});
	const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});

	return (
		<Grid container spacing={4}>
			<Grid item container xs={12} md={7.5} lg={6} alignItems={'center'}>
				<Box>
					{!isMd && (
						// <Box
						//   sx={{
						//     width: '100%',
						//     height: '100%',
						//     display: 'flex',
						//     alignItems: 'center',
						//     justifyContent: 'center',
						//   }}
						// >
						<Box
							mt={0}
							mb={4}
							sx={{
								position: 'relative',
								// maxWidth: '450px',
								maxWidth: isSm ? '450px' : '90%',
							}}
						>
							<Box>
								<Box
									position={'relative'}
									zIndex={2}
									maxWidth={1}
									height={'auto'}
									sx={{ verticalAlign: 'middle' }}
								>
									<LaptopSkeletonIllustration />
								</Box>
								<Box
									position={'absolute'}
									top={'5%'}
									left={'11%'}
									width={'78%'}
									height={'83%'}
									border={`1px solid ${theme.palette.alternate.dark}`}
									zIndex={3}
								>
									<ImageLoader
										delay={true}
										intersectViewportCheck={true}
										childRef={dashboard_laptopRef_1}
									>
										<Box
											ref={dashboard_laptopRef_1}
											component={'img'}
											src={dashboard_laptop}
											alt='Professionelle Dashboardanwendung auf einem Laptop'
											width={1}
											height={1}
											sx={{
												objectFit: 'cover',
												filter: theme.palette.mode === 'dark' ? 'brightness(0.95)' : 'none',
											}}
										/>
									</ImageLoader>
								</Box>
							</Box>
						</Box>
						// </Box>
					)}
					<Box marginBottom={2}>
						<Typography
							component='h1'
							variant='h3'
							color='text.primary'
							sx={{
								fontWeight: 700,
							}}
						>
							{/* <span style={{ wordBreak: 'break-word', hyphens: 'auto' }}>Anwendungsenwicklung für </span> */}
							{t('hero_headline_1', { hyphen: '\u00AD' })}
							<Typography
								// component='h1'
								// variant='h3'
								// color='text.primary'
								// sx={{
								//   fontWeight: 700,
								// }}
								component='span'
								variant='inherit'
								color='inherit'
								sx={{
									fontWeight: 700,
								}}

								// sx={{
								// 	background: `linear-gradient(180deg, transparent 93%, ${alpha(theme.palette.secondary.main, 0.9)} 0%)`
								// }}
							>
								{t('hero_headline_2')}
							</Typography>
						</Typography>
					</Box>

					<Box marginBottom={3}>
						<Typography component={'h2'} variant='h6' color='text.secondary'>
							{t('hero_subheadline', { context: '1' })}
							<Box component={'span'} display={{ xs: 'none', md: 'inline' }}>
								<br></br>
							</Box>
							{t('hero_subheadline', { context: '2' })}
						</Typography>
					</Box>
					{/* <Box display='flex' flexDirection={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretched', sm: 'flex-start' }}> */}
					<Grid
						container
						spacing={{ xs: 0, sm: 2, md: 2 }}
						direction='row'
						justifyContent='flex-start'
						alignItems='center'
					>
						<Grid item xs={12} sm={6} md={'auto'}>
							<Button
								sx={{
									borderRadius: '0',
									// marginRight: isMd ? "0%" : "5px",
									rel: 'nofollow',
								}}
								variant='contained'
								color='primary'
								size='large'
								onClick={(e) => {
									e.preventDefault();
									// let support = document.getElementById('support');
									// support?.scrollIntoView({ behavior: 'smooth' });

									Scroll.scroller.scrollTo('start-dev', {
										duration: 1500,
										// delay: 100,
										smooth: true,
										// containerId: 'ContainerElementID',
										offset: -20, // Scrolls to element + 50 pixels down the page
									});
								}}
								fullWidth={isMd ? false : true}
							>
								{t('hero_button_1')}
							</Button>
						</Grid>

						<Grid item xs={12} sm={6} md={'auto'}>
							<Link
								to={link_prefix + '/contact/?scrollTo=video-call'}
								prefetch='intent'
								style={{
									textDecoration: 'none',
									width: isMd ? 'auto' : '100%',
								}}
								onClick={(e) => {
									e.stopPropagation();
								}}
							>
								<Box
									sx={{
										borderRadius: '0',
									}}
									component={Button}
									variant='outlined'
									color='primary'
									size='large'
									marginTop={{ xs: 2, sm: 0 }}
									fullWidth={isMd ? false : true}
								>
									{t('hero_button_2')}
								</Box>
							</Link>
						</Grid>
					</Grid>
				</Box>
			</Grid>

			{/* <Grid
				item
				container
				alignItems={'center'}
				justifyContent={'center'}
				xs={12}
				md={6}
				data-aos="fade-left"
				data-aos-easing="ease-out-cubic"
				data-aos-duration="1000"
				spacing={2}
			> */}
			{isMd && (
				// <ReactPlayer muted={true} playing={true} loop={true} url={[{ src: video2, type: 'video/mp4' }]} />
				<Grid item xs={6} md={4.5} lg={6}>
					<Box
						sx={{
							position: 'relative',
							marginX: 'auto',
						}}
					>
						<Box
							sx={{
								position: 'relative',
								marginX: 'auto',
							}}
						>
							<Box>
								<Box
									position={'relative'}
									zIndex={2}
									maxWidth={1}
									height={'auto'}
									sx={{ verticalAlign: 'middle' }}
								>
									<LaptopSkeletonIllustration />
								</Box>
								<Box
									position={'absolute'}
									top={'6.5%'}
									left={'11%'}
									width={'78%'}
									height={'84%'}
									border={`1px solid ${theme.palette.alternate.dark}`}
									zIndex={3}
								>
									<ImageLoader
										delay={true}
										intersectViewportCheck={true}
										childRef={dashboard_laptopRef_2}
									>
										<Box
											ref={dashboard_laptopRef_2}
											component={'img'}
											src={dashboard_laptop}
											alt='Professionelle Dashboardanwendung auf einem Laptop'
											width={1}
											height={1}
											sx={{
												objectFit: 'cover',
												filter: theme.palette.mode === 'dark' ? 'brightness(0.95)' : 'none',
											}}
										/>
									</ImageLoader>
								</Box>
							</Box>
						</Box>
					</Box>
				</Grid>
			)}

			{/* <Box
				component={LazyLoadImage}
				height={1}
				width={1}
				src={''}
				alt="..."
				effect="blur"
				boxShadow={3}
				borderRadius={2}
				maxWidth={600}
				sx={{
					filter: theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
				}}
				/> */}
		</Grid>
		// </Grid>
	);
};

export default Hero;
